<template>
    <section>
        <h1>
            Page introuvable
        </h1>
        <small>Code 404</small>
        <br>
        <i>&laquo; Il y a une différence entre connaître le chemin et arpenter le chemin. &raquo;</i>

        <p>Un choix s'offre à vous</p>

        <div class="pills-box">
            <div class="grid grid-cols-2 gap-36 my-16">
                <div>
                    <router-link :to="{ name: 'hello'}" class="pill pill--red" tabindex="0">Revenir à l'accueil</router-link>
                </div>
                <div>
                    <router-link :to="{ name: 'articles'}" class="pill pill--blue" tabindex="1">Un peu de lectures</router-link>
                </div>
            </div>

            <!-- <img alt="" role="presentation" src="@/assets/icon/matrix-2.png" class="my-16"> -->
        </div>
    </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
    0% {
        opacity: 0;
        transform: translateY(1em);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

section {
    height: 70vh;
    padding-top: 4em;
    text-align: center;

    background-image: url('@/assets/icon/matrix-3.png');
    background-repeat: no-repeat;
    background-size: 30%;
    background-position: center 5em;
    animation: fadeIn 1s;
}


.pills-box {
    position: relative;
    width: 50%;
    margin: auto;
    opacity: 0;
    animation: fadeIn 1s forwards;
    animation-delay: 1s;

    &:before {
        content: "";
        z-index: -1;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(-45deg, #45caff 0%, #ff1b6b 100% );
        transition: filter 350ms ease;
        transform: translate3d(0px, 20px, 0) scale(0.95);
        filter: blur(20px);
        opacity: var(0.7);
        transition: opacity 0.3s;
        border-radius: inherit;
    }

    /*
    * Prevents issues when the parent creates a
    * stacking context. (For example, using the transform
    * property )
    */
    &:after {
        content: "";
        z-index: -1;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: inherit;
        border-radius: inherit;
    }

    .pill {
        display: block;
        padding: 1em;
        color: #000;
        text-decoration: none;
        font-weight: bold;
        background-color: #fff;
        border-radius: 30px;
        transition: all 350ms ease;



        &--red {
            background-color: #ff1b6b;

            &:hover {
                transform: translateY(-0.25em) scale(1.05);
                background-color: lighten(#ff1b6b, 10%);
            }
        }

        &--blue {
            background-color: #45caff;

            &:hover {;
                transform: translateY(-0.25em) scale(1.05);
                background-color: lighten(#45caff, 15%);
            }
        }
    }
}

small {
    font-size: 1.5rem;
}

h1 {
    padding-top: 1em;
    margin-bottom: 0;
    font-size: 4rem;
    text-transform: uppercase;
}

p {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    opacity: 0;
    font-size: 2.3rem;
    animation: fadeIn 1s forwards;
    animation-delay: 0.5s;
}

@media screen and (max-width: 620px) {
    section {
        padding-top: 2em;
        background-position: center 2em;
    }
    h1 {
        font-size: 2.5rem;
    }

    small {
        font-size: 1rem;
    }

    .pills-box {
        width: 95%;
    }
}
</style>